<template>
  <v-container>
    <v-tabs
      fixed-tabs
      v-model="active"
      slider-color="primary"
      class="futuristic-tabs"
    >
      <v-tab key="types" ripple class="futuristic-tab">Accommodation and Camping Types</v-tab>
      <v-tab key="groups" ripple class="futuristic-tab">Special Pricing Groups</v-tab>
      <v-tab key="allocations" ripple class="futuristic-tab">Allocation</v-tab>
      
      <v-tab-item key="types">
        <v-layout row wrap>
          <v-flex lg6 md6 sm12 xs12>
            <v-container>
              <v-card flat class="futuristic-card">
                <v-card-title class="card-header">
                  <h4 class="earth-color">ADD ACCOMMODATION AND CAMPING TYPES</h4>
                </v-card-title>
                <v-container>
                  <v-form @submit.prevent="postFacilityType()">
                    <v-text-field
                      label="Name"
                      v-model="types.name"
                      :rules="requiredRules"
                      required
                      class="futuristic-input"
                      outlined
                    ></v-text-field>
                    <v-textarea
                      label="Description"
                      v-model="types.description"
                      :rules="requiredRules"
                      required
                      class="futuristic-input"
                      outlined
                    ></v-textarea>
                    <v-btn 
                      :depressed="true" 
                      color="primary" 
                      block 
                      v-if="update === false" 
                      type="submit"
                      class="futuristic-btn"
                    >Add Type</v-btn>
                    <v-btn 
                      :depressed="true" 
                      color="warning" 
                      block  
                      v-if="update === true" 
                      type="submit"
                      class="futuristic-btn"
                    >Update Type</v-btn>
                  </v-form>
                </v-container>
              </v-card>
            </v-container>
          </v-flex>
          
          <v-flex lg6 md6 sm12 xs12>
            <v-container>
              <v-card flat class="futuristic-card">
                <v-card-title class="card-header">
                  <h4 class="earth-color">ACCOMMODATION AND CAMPING TYPES</h4>
                </v-card-title>
                <v-container>
                  <table cellpadding="1" cellspacing="1" class="futuristic-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Description</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(type, index) in allFacilityTypes" :key="index" class="futuristic-table-row">
                        <td class="futuristic-cell">{{index + 1}}</td>
                        <td class="futuristic-cell">{{type.name}}</td>
                        <td class="futuristic-cell">{{type.description}}</td>
                        <td class="futuristic-cell">
                          <v-btn 
                            :depressed="true" 
                            small 
                            color="error" 
                            @click="deleteFacilityType(type.public_id)"
                            class="futuristic-btn futuristic-btn-sm"
                          >Disable</v-btn>
                          <v-btn 
                            :depressed="true" 
                            small 
                            color="info" 
                            v-if="update === false" 
                            @click="editFacilityType(type)"
                            class="futuristic-btn futuristic-btn-sm"
                          >Amend</v-btn>
                          <v-btn 
                            :depressed="true" 
                            small 
                            color="warning" 
                            v-if="update === true" 
                            @click="cancelEditFacilityType(index)"
                            class="futuristic-btn futuristic-btn-sm"
                          >Cancel Amend</v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </v-container>
              </v-card>
            </v-container>
          </v-flex>
        </v-layout>
      </v-tab-item>
      
      <v-tab-item key="groups">
        <special-pricing-groups></special-pricing-groups>
      </v-tab-item>
      
      <v-tab-item key="allocations">
        <v-layout row wrap>
          <v-flex lg6 md6 sm12 xs12>
            <v-container>
              <v-card flat class="futuristic-card">
                <v-card-title class="card-header">
                  <h4 class="earth-color">ADD ALLOCATION</h4>
                </v-card-title>
                <v-container>
                  <v-form @submit.prevent="postAllocation()">
                    <v-text-field
                      label="Name"
                      v-model="allocation.name"
                      :rules="requiredRules"
                      required
                      class="futuristic-input"
                      outlined
                    ></v-text-field>
                    <v-text-field
                      label="Description"
                      v-model="allocation.description"
                      :rules="requiredRules"
                      required
                      multi-line
                      class="futuristic-input"
                      outlined
                    ></v-text-field>
                    <v-btn 
                      :depressed="true" 
                      color="primary" 
                      v-if="update2 === false" 
                      type="submit"
                      class="futuristic-btn"
                    >Add Allocation</v-btn>
                    <v-btn 
                      :depressed="true" 
                      color="warning" 
                      v-if="update2 === true" 
                      type="submit"
                      class="futuristic-btn"
                    >Update Allocation</v-btn>
                  </v-form>
                </v-container>
              </v-card>
            </v-container>
          </v-flex>
          
          <v-flex lg6 md6 sm12 xs12>
            <v-container>
              <v-card flat class="futuristic-card">
                <v-card-title class="card-header">
                  <h4 class="earth-color">ALLOCATIONS</h4>
                </v-card-title>
                <v-container>
                  <table cellpadding="1" cellspacing="1" class="futuristic-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Name</th>
                        <th>Description</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(allocation, index) in allFacilityAllocation" :key="index" class="futuristic-table-row">
                        <td class="futuristic-cell">{{index + 1}}</td>
                        <td class="futuristic-cell">{{allocation.name}}</td>
                        <td class="futuristic-cell">{{allocation.description}}</td>
                        <td class="futuristic-cell">
                          <v-btn 
                            :depressed="true" 
                            small 
                            color="error" 
                            @click="deleteAllocation(allocation.public_id)"
                            class="futuristic-btn futuristic-btn-sm"
                          >Disable</v-btn>
                          <v-btn 
                            :depressed="true" 
                            small 
                            color="info" 
                            v-if="update2 === false" 
                            @click="editAllocation(allocation)"
                            class="futuristic-btn futuristic-btn-sm"
                          >Amend</v-btn>
                          <v-btn 
                            :depressed="true" 
                            small 
                            color="warning" 
                            v-if="update2 === true" 
                            @click="cancelEditAllocation(index)"
                            class="futuristic-btn futuristic-btn-sm"
                          >Cancel Amend</v-btn>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </v-container>
              </v-card>
            </v-container>
          </v-flex>
        </v-layout>
      </v-tab-item>
    </v-tabs>
  </v-container>
</template>

<script>
import SpecialPricingGroups from './SpecialPricingGroups'
export default {
  components: { SpecialPricingGroups },
  data () {
    return {
      active: '',
      requiredRules: [
        v => !!v || 'This field is required'
      ],
      update: false,
      update2: false,
      types: {
        name: '',
        description: '',
        public_id: '',
        session_id: localStorage.getItem('lkjhgfdsa')
      },
      allocation: {
        name: '',
        description: '',
        public_id: '',
        session_id: localStorage.getItem('lkjhgfdsa')
      }
    }
  },
  created () {
    this.$store.dispatch('get_all_facility_types')
    this.$store.dispatch('get_all_facility_allocations')
  },
  methods: {
    deleteFacilityType: function (publicId) {
      var data = {
        public_id: publicId,
        deleted_by: localStorage.getItem('lkjhgfdsa')
      }
      this.$store.dispatch('delete_facility_type', data)
    },
    deleteAllocation: function (publicId) {
      var data = {
        public_id: publicId,
        deleted_by: localStorage.getItem('lkjhgfdsa')
      }
      this.$store.dispatch('delete_facility_allocation', data)
    },
    clearFields () {
      this.types.name = ''
      this.types.description = ''
      this.types.public_id = ''
      this.update = false
    },
    postFacilityType: function () {
      if (this.update === false) {
        this.$store.dispatch('post_facility_type', this.types).then(function () {
          this.clearFields()
        })
      } else {
        this.$store.dispatch('update_facility_type', this.types).then(function () {
          this.clearFields()
        })
      }
    },
    editFacilityType: function (type) {
      this.update = true
      this.types.name = type.name
      this.types.description = type.description
      this.types.public_id = type.public_id
    },
    editAllocation: function (allocation) {
      this.update2 = true
      this.allocation.name = allocation.name
      this.allocation.description = allocation.description
      this.allocation.public_id = allocation.public_id
    },
    cancelEditFacilityType: function () {
      this.update = false
      this.types.name = ''
      this.types.description = ''
      this.types.public_id = ''
    },
    cancelEditAllocation: function () {
      this.update2 = false
      this.allocation.name = ''
      this.allocation.description = ''
      this.allocation.public_id = ''
    },
    // Currency
    deleteCurrency: function (publicId) {
      this.$store.dispatch('delete_facility_currency', publicId)
    },
    postAllocation: function () {
      var instance = this
      if (this.update2 === false) {
        this.$store.dispatch('post_facility_allocation', this.allocation)
      } else {
        this.$store.dispatch('update_facility_allocation', this.allocation).then(function () {
          instance.update2 = false
        })
      }
    },
    editCurrency: function (index) {
      this.update2 = true
      var currency = this.allFacilityCurrency[index]
      this.currency.name = currency.name
      this.currency.description = currency.description
      this.currency.public_id = currency.public_id
    },
    cancelEditCurrency: function () {
      this.update2 = false
      this.currency.name = ''
      this.currency.description = ''
      this.currency.public_id = ''
    }
  }
}
</script>

<style scoped>
/* Futuristic Tabs */
.futuristic-tabs {
  border-radius: 8px;
  background: #ffffff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.futuristic-tab {
  font-weight: 500;
  text-transform: none;
  color: #4caf50;
}

.futuristic-tabs >>> .v-tabs__div {
  min-width: 0;
  padding: 0 24px;
}

.futuristic-tabs >>> .v-tabs__bar {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
}

/* Futuristic Card */
.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  margin-bottom: 16px;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px 8px 0 0;
}

.earth-color {
  color: #4caf50;
  font-weight: 600;
  margin: 0;
}

/* Form Elements */
.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
  margin-bottom: 16px;
}

.futuristic-input >>> .v-text-field__slot input,
.futuristic-input >>> .v-text-field__slot textarea {
  font-family: 'Roboto Mono', monospace;
}

/* Futuristic Table */
.futuristic-table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.futuristic-table thead {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
}

.futuristic-table th {
  color: #4caf50;
  font-weight: 600;
  padding: 12px 8px;
  text-align: left;
  font-size: 13px;
}

.futuristic-table-row {
  transition: background-color 0.2s ease;
}

.futuristic-table-row:hover {
  background-color: #f5f7fa;
}

.futuristic-cell {
  padding: 12px 8px;
  border-bottom: 1px solid #e0e0e0;
  font-family: 'Roboto Mono', monospace;
}

/* Button Styling */
.futuristic-btn {
  border-radius: 8px;
  text-transform: none;
  font-weight: 500;
  transition: all 0.2s ease;
  margin: 4px;
}

.futuristic-btn-sm {
  font-size: 0.85rem;
  padding: 0 12px;
  height: 32px;
}

.futuristic-btn:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

/* Responsive Adjustments */
@media (max-width: 960px) {
  .card-header {
    padding: 12px;
  }
  
  .futuristic-table {
    display: block;
    overflow-x: auto;
  }
  
  .futuristic-btn {
    margin: 2px;
    font-size: 0.9rem;
  }
  
  .futuristic-btn-sm {
    font-size: 0.8rem;
    padding: 0 8px;
    height: 28px;
  }
}

@media (max-width: 600px) {
  .futuristic-tabs >>> .v-tabs__div {
    padding: 0 12px;
    font-size: 0.9rem;
  }
  
  .futuristic-card {
    border-radius: 6px;
  }
  
  .card-header {
    border-radius: 6px 6px 0 0;
  }
  
  .futuristic-input >>> .v-input__slot {
    border-radius: 6px;
  }
  
  .futuristic-btn {
    border-radius: 6px;
    width: 100%;
    margin: 4px 0;
  }
  
  .futuristic-cell {
    font-size: 0.85rem;
    padding: 8px 6px;
  }
}
</style>